export const browserRoutes = {
  // auth
  login: "/login",
  createAccount: "/create-account",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  profile: "/profile",
  changePassword: "/change-password",
  // analytics
  analytics: "/analytics",

  // users
  users: "/users",
  viewUser: "/users/view",

  //contact us
  contactUs: "/contact-us",

  //category
  category: "/category",
  addCategory: "/category/add",
  editCategory: "/category/edit",

  //recipe
  recipe: "/recipe",
  addRecipe: "/recipe/add",
  editRecipe: "/recipe/edit",
  viewRecipe: "/recipe/view",

  // static page
  staticPage: "/static-page",
  editStaticPage: "/static-page/edit",

  // subscription management
  subscriptionManagement: "/subscription-management",
  addSubscriptionPlan: "/subscription-management/add",
  editSubscriptionPlan: "/subscription-management/edit",

  // notification management
  notificationManagement: "/notification-management",
  addNotificationTemplate: "/notification-management/add",
  editNotificationTemplate: "/notification-management/edit",

  // public pages (no auth required)
  privacyPolicy: "/privacy-policy",
  termsOfService: "/terms-of-service",
};
